import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useMultiChipSelectStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      minWidth: 120,
      width: '100%',
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: '0.5rem 1.2rem',
      marginRight: '3rem',
    },
    chip: {
      backgroundColor: 'unset',
      borderRadius: theme.borderRadius[100],
      border: `1px solid ${theme.colors.borderDefault}`,
      margin: 3,
      '&.selected': {
        backgroundColor: theme.colors.bgDarker,
        borderColor: theme.colors.bgDarker,
        color: theme.colors.fgContrast,
        cursor: 'pointer',
      },
      '&:focus': {
        boxShadow: theme.boxShadows.focus,
      },
    },
    selectedChips: {
      '& .MuiOutlinedInput-input': {
        padding: 0,
        height: 'auto',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important',
        borderColor: theme.colors.borderDefault,
      },
    },
    noSelectedChips: {
      '& .MuiOutlinedInput-input': {
        padding: '14px 12px 15px',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important',
        borderColor: theme.colors.borderDefault,
      },
    },
    chipOptions: {
      padding: '1rem 1.5rem',
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
    emptyStateLabel: {
      color: theme.colors.fgSubtle,
    },
    sectionDivider: {
      borderTop: `1px solid ${theme.colors.borderDefault}`,
      margin: '1.2rem 0',
      width: '100%',

      '&:first-of-type': {
        display: 'none',
      },
    },
    root: {
      backgroundColor: theme.colors.bgDefault,
      '&.MuiSelect-select:focus': {
        backgroundColor: theme.colors.bgDefault,
      },
    },
  })
);
